import { Component, OnInit } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import * as ChartConfig from './scratchpad-chart.config';

@Component({
    selector: 'app-scratchpad',
    templateUrl: './scratchpad.component.html',
    styleUrls: ['./scratchpad.component.scss']
})
export class ScratchPadComponent implements OnInit {
    public isLoading = true;

    public comboChartType: ChartType = 'bar';
    public comboChartLabels: Label[] = [];
    public comboChartData: ChartDataSets[] = [];
    public comboChartOptions: ChartOptions = ChartConfig.comboChartOptions;

    public pieChartType: ChartType = 'pie';
    public pieChartLabels: Label[] = [];
    public pieChartData: number[] = [];
    public pieChartColors = [{ backgroundColor: [] }];
    public pieChartOptions: ChartOptions = ChartConfig.pieChartOptions;

    constructor() {}

    ngOnInit(): void {
        this.fetchChartData();
    }

    private async fetchChartData(): Promise<void> {
        try {
            const [performanceData, channelData] = await Promise.all([
                this.fetchPerformanceData(),
                this.fetchChannelData()
            ]);

            this.comboChartLabels = performanceData.labels;
            this.comboChartData = [
                {
                    type: 'bar',
                    label: 'Estimated Plays',
                    data: performanceData.plays,
                    backgroundColor: 'rgba(255, 193, 7, 0.8)',
                    borderColor: 'rgba(255, 193, 7, 1)',
                    borderWidth: 1,
                    yAxisID: 'y-axis-0',
                    order: 2
                },
                {
                    type: 'line',
                    label: 'Spent',
                    data: performanceData.spend,
                    borderColor: 'rgba(244, 67, 54, 1)',
                    backgroundColor: 'rgba(244, 67, 54, 0.1)',
                    borderWidth: 2,
                    borderDash: [5, 5],
                    fill: false,
                    yAxisID: 'y-axis-1',
                    order: 1
                }
            ];

            this.pieChartLabels = channelData.labels;
            this.pieChartData = channelData.values;
            this.pieChartColors = [
                {
                    backgroundColor: ChartConfig.generateColors(channelData.values.length)
                }
            ];

            this.isLoading = false;
        } catch (error) {
            this.isLoading = false;
        }
    }

    private fetchPerformanceData(): Promise<{
        labels: Label[];
        plays: number[];
        spend: number[];
    }> {
        return new Promise(resolve => {
            setTimeout(() => {
                const labels: Label[] = [];
                const plays: number[] = [];
                const spend: number[] = [];

                const startDate = new Date('2025-09-01');
                for (let i = 0; i < 10; i++) {
                    const currentDate = new Date(startDate);
                    currentDate.setDate(startDate.getDate() + i);
                    labels.push(currentDate.toISOString().split('T')[0]);

                    plays.push(Math.floor(Math.random() * 5000) + 8000);
                    spend.push(Math.floor(Math.random() * 300) + 400);
                }

                resolve({
                    labels,
                    plays,
                    spend
                });
            }, 1500);
        });
    }

    private fetchChannelData(): Promise<{ labels: Label[]; values: number[] }> {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    labels: [
                        'Channel 1',
                        'Channel 2',
                        'Channel 3',
                        'Channel 4',
                        'Channel 5',
                        'Channel 6'
                    ],
                    values: [3430, 2410, 2170, 1450, 960, 4321]
                });
            }, 1200);
        });
    }
}
